export interface BrowserDiagnostics {
  browserName: string;
  browserVersion: string;
  osName: string;
  isInAppBrowser: boolean;
  inAppName?: string;
  isOnline: boolean;
  userAgent: string;
  language: string;
  screenSize: string;
}

export function getBrowserDiagnostics(): BrowserDiagnostics {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const isOnline = typeof navigator !== "undefined" ? navigator.onLine !== false : true;
  const language = typeof navigator !== "undefined" ? navigator.language || "" : "";
  const screenSize =
    typeof window !== "undefined"
      ? `${window.innerWidth}x${window.innerHeight} (صفحه: ${window.screen?.width || 0}x${window.screen?.height || 0})`
      : "";

  let browserName = "مرورگر ناشناخته";
  let browserVersion = "";

  // Detect In-App Browsers
  let isInAppBrowser = false;
  let inAppName: string | undefined;

  if (/Telegram/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "تلگرام (Telegram)";
  } else if (/Instagram/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "اینستاگرام (Instagram)";
  } else if (/Rubika/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "روبیکا (Rubika)";
  } else if (/Bale/i.test(ua) || /bale\.apk/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "بله (Bale)";
  } else if (/Eitaa/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "ایتا (Eitaa)";
  } else if (/WhatsApp/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "واتس‌اپ (WhatsApp)";
  } else if (/FBAN|FBAV/i.test(ua)) {
    isInAppBrowser = true;
    inAppName = "فیسبوک (Facebook)";
  }

  // Detect Browser Family & Version
  if (/SamsungBrowser\/([0-9.]+)/i.test(ua)) {
    browserName = "Samsung Internet";
    browserVersion = RegExp.$1;
  } else if (/Edg\/([0-9.]+)/i.test(ua)) {
    browserName = "Microsoft Edge";
    browserVersion = RegExp.$1;
  } else if (/OPR\/([0-9.]+)/i.test(ua) || /Opera/i.test(ua)) {
    browserName = "Opera";
    browserVersion = RegExp.$1 || "";
  } else if (/Chrome\/([0-9.]+)/i.test(ua)) {
    browserName = "Google Chrome";
    browserVersion = RegExp.$1;
  } else if (/Firefox\/([0-9.]+)/i.test(ua)) {
    browserName = "Mozilla Firefox";
    browserVersion = RegExp.$1;
  } else if (/Version\/([0-9.]+).*Safari/i.test(ua)) {
    browserName = "Apple Safari";
    browserVersion = RegExp.$1;
  }

  // Detect OS
  let osName = "سیستم‌عامل نامشخص";
  if (/Android\s*([0-9.]+)?/i.test(ua)) {
    osName = `اندروید ${RegExp.$1 || ""}`.trim();
  } else if (/iPhone|iPad|iPod/i.test(ua)) {
    const match = /OS\s*([0-9_]+)/i.exec(ua);
    const v = match ? match[1].replace(/_/g, ".") : "";
    osName = `آی‌اواس (iOS ${v})`.trim();
  } else if (/Windows NT 10.0/i.test(ua)) {
    osName = "ویندوز 10 / 11";
  } else if (/Windows NT 6.1/i.test(ua)) {
    osName = "ویندوز 7";
  } else if (/Windows/i.test(ua)) {
    osName = "ویندوز";
  } else if (/Mac OS X\s*([0-9_]+)?/i.test(ua)) {
    const match = /Mac OS X\s*([0-9_]+)/i.exec(ua);
    const v = match ? match[1].replace(/_/g, ".") : "";
    osName = `مک‌او‌اس (macOS ${v})`.trim();
  } else if (/Linux/i.test(ua)) {
    osName = "لینوکس";
  }

  return {
    browserName,
    browserVersion,
    osName,
    isInAppBrowser,
    inAppName,
    isOnline,
    userAgent: ua,
    language,
    screenSize,
  };
}

export function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).then(() => true).catch(() => fallbackCopy(text));
  }
  return Promise.resolve(fallbackCopy(text));
}

function fallbackCopy(text: string): boolean {
  try {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const success = document.execCommand("copy");
    document.body.removeChild(textArea);
    return success;
  } catch {
    return false;
  }
}
